module.exports = dormakaba.vendorTerrific['vendor/mobx'];